/// <reference path="./Tag.ts" />
namespace HA.Core.HTML {
    export class Anchor extends Tag {

        public getTagName(): string {
            return "a";
        }

        public getTag(): Tag {
            const tag = this.get("tag");

            if (tag) {
                return tag;
            }

            if (this instanceof Tag) {
                return this;
            }

            return null;
        }

        protected initialize(data: any) {
            super.initialize(data);
            if (data.get("d")) {
                this.addAttribute("d", data.get("d"));
                this.addAttribute("t", data.get("t"));
                this.addAttribute("target", data.get("target"));
            }
            if (data.get("href")) {
                this.addAttribute("href", data.get("href"));
            }
            const me = this;

            this.onClick((event: MouseEvent) => {
                event.stopImmediatePropagation();
                me.processClick();
            });
        }

        protected getType() {
            return this.getTag().getAttribute("t");
        }

        protected getTarget(): string {
            let target = this.getTag().getAttribute("target");
            if (!target) {
                target = this.has("target") ? this.get("target") : "_blank";
            }
            return target;
        }

        protected getCData() {
            const d = this.getTag().getAttribute("d");
            try {
                return toMap(JSON.parse(d));
            } catch (e) {
                log2(e);
                return d;
            }
        }

        protected getMData() {
            const d = this.getTag().getAttribute("d");

            const result: Array<Map<any, any> | string> = new Array<Map<any, any>>();
            try {
                if (JSON.parse(d)) {
                    const da = JSON.parse(d);
                    if (typeof da === "string") {
                        return da;
                    }
                    da.forEach((e: any) => {
                        if (typeof e === "string") {
                            result.push(e);
                        } else {
                            result.push(toMap(e));
                        }
                    });
                }
            } catch (e) {
                return d;
            }

            return result;
        }

        protected notify() {
            const n = this.get("n");
            if (n && n instanceof Function) {
                n();
            }
        }

        protected processClick() {
            this.notify();

            const data = this.getCData();
            switch (this.getType()) {
                case  "form" :
                    this.processForm(data);
                    break;
                case  "i" :
                    this.processInteractive(data);
                    break;
                case  "showAppMenu" :
                    getWebPageService().showAppMenu(this.getMData());
                    break;
                case  "url" :
                    const target = this.getTarget();
                    window.open("" + this.getMData(), target);
                    break;
                case  "cpy" :
                    this.copy2Clip(this.getMData());
                    break;
                default :
                    data.set("t", this.getType());
                    getAppService().processAction(data);
                    break;
            }
        }

        protected copy2Clip(str) {
            const el = document.createElement("textarea");
            el.setAttribute("readonly", "");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            el.value = str;
            document.body.appendChild(el);
            const selected =
            document.getSelection().rangeCount > 0
            ? document.getSelection().getRangeAt(0)
            : false;
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            if (selected) {
                document.getSelection().removeAllRanges();
                document.getSelection().addRange(selected);
            }

        }

        protected processForm(data: any) {
            const me = this;

            getDataRepository().saveForm(data).then((response: Map<any, any>) => {
                const todo = response.get("todo");
                if (response.get("msg")) {
                    log(response.get("msg"));
                }
                if (todo) {
                    switch (todo) {
                        case "reload":
                            getWebPageService().reloadApp(toMap({id: response.get("id")}));
                            break;
                        case "success":
                            getWebPageService().reloadApp(toMap({id: response.get("id")}));
                            break;
                        case "app":
                            getWebPageService().reloadApp(toMap({id: response.get("id")}));
                            break;
                        default:
                            getAppService().processAction(response);
                            break;
                    }
                } else {
                    getAppService().processAction(response);
                }
            }).catch((reason: any) => {
                /// log(["eRRRR", reason]);
            });

        }

        protected updateDom(data: Map<any, any>): void {
            const doma: any = data.get("doma");
            switch (doma) {
                case "repl":
                    const t: Tag = this.findById(data.get("eid"), true);
                    t.clear();
                    t.appendChild(new Tag(data.get("c")));
                    break;
                default:

            }
        }

        protected processInteractive(data: any) {
            const me = this;

            getDataRepository().fetchData(data).then((response: Map<any, any>) => {
                me.processAction(response);
            }).catch((reason: any) => {
                 ptime(["eRRRR", reason]);
            });
        }
        protected processAction(data : Map<string, any>) {
            const todo = data.get("todo");
            if (data.get("msg")) {
                log(data.get("msg"));
            }
            if (todo) {
                switch (todo) {
                    case "reload":
                        getWebPageService().reloadApp(toMap(data.get("d")));
                        break;
                    case "success":
                    case "app":
                        getWebPageService().reloadApp(toMap(data.get("d")));
                        break;
                    case "url":
                        timeout(() => {
                            window.open(data.get("url"), data.get("target"));
                        }, 200);

                        break;
                    case "dom":
                        this.updateDom(data);
                        break;
                    case  "bulk" :
                    case  "steps" :
                        this.processBulkAction(data.get("steps"));
                        break;

                    default:
                        getAppService().processAction(data);
                        break;
                }
            } else {
                getAppService().processAction(data);
            }
        }

        protected processBulkAction(data: any[]) {
            for (const item of data) {
                this.processAction(toMap(item));
            }
        }
    }


    interface INavigation {
        toggleApp: (d: any) => void;
        showApp: (d: any) => void;
        reloadApp: (d?: any) => void;
        showAppMenu: (d: any) => void;
    }
}
